module.exports = __webpack_public_path__ + "img/71.dde91fa4.jpeg";